import { api } from '../utils/apiClient';

export const campaignService = {
  async getAll(params) {
    return api.get('/campaigns', params);
  },

  async getById(id) {
    return api.get('/campaigns/' + id);
  },

  async create(campaign) {
    return api.post('/campaigns', campaign);
  },

  async update(id, patch) {
    return api.put('/campaigns/' + id, patch);
  },

  async remove(id) {
    return api.del('/campaigns/' + id);
  },

  async launch(id) {
    return api.post('/campaigns/' + id + '/launch');
  },

  async pause(id) {
    return api.post('/campaigns/' + id + '/pause');
  },

  async resume(id) {
    return api.post('/campaigns/' + id + '/resume');
  },

  async cancel(id) {
    return api.post('/campaigns/' + id + '/cancel');
  },

  async duplicate(id) {
    return api.post('/campaigns/' + id + '/duplicate');
  },

  async analytics(id) {
    return api.get('/campaigns/' + id + '/analytics');
  },
};
